import React from 'react';
import { Search, Bell } from 'lucide-react';
import { Input } from './ui/input';
import { Avatar, AvatarFallback, AvatarImage } from './ui/avatar';
import { Badge } from './ui/badge';
import { useAuth } from '../contexts/AuthContext';

const Topbar = () => {
  const { user, getRoleLabel } = useAuth();
  
  const notificacoes = 3;

  // Get first name
  const primeiroNome = user?.nome?.split(' ')[0] || 'Usuário';

  // Get initials for avatar fallback
  const iniciais = user?.nome
    ?.split(' ')
    .map(n => n[0])
    .join('')
    .slice(0, 2)
    .toUpperCase() || 'U';

  return (
    <header className="fixed top-0 right-0 left-72 h-20 border-b border-border bg-background/95 backdrop-blur-sm flex items-center justify-between px-8 z-40">
      {/* Search */}
      <div className="flex-1 flex justify-center">
        <div className="relative w-full max-w-md">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
          <Input
            type="text"
            placeholder=""
            className="pl-10 bg-secondary border-none h-11 w-full focus:ring-1 focus:ring-primary"
          />
        </div>
      </div>

      {/* Right Section */}
      <div className="flex items-center gap-6">
        {/* Notification Bell */}
        <button className="relative text-muted-foreground hover:text-foreground transition-colors">
          <Bell className="h-5 w-5" />
          {notificacoes > 0 && (
            <span className="absolute -top-1 -right-1 h-4 w-4 bg-primary text-[10px] font-bold text-primary-foreground rounded-full flex items-center justify-center">
              {notificacoes}
            </span>
          )}
        </button>
        
        <div className="flex items-center gap-3">
          <div className="text-right">
            <span className="text-sm block">
              Olá, <span className="text-primary font-medium">{primeiroNome}</span>
            </span>
            {user?.role && (
              <Badge variant="secondary" className="text-[10px] px-1.5 py-0 h-4 bg-primary/20 text-primary">
                {getRoleLabel(user.role)}
              </Badge>
            )}
          </div>
          <Avatar className="h-12 w-12 border-2 border-primary">
            {user?.avatar ? (
              <AvatarImage src={user.avatar} alt={user?.nome} />
            ) : null}
            <AvatarFallback className="bg-primary/20 text-primary font-semibold">
              {iniciais}
            </AvatarFallback>
          </Avatar>
        </div>
      </div>
    </header>
  );
};

export default Topbar;
